import React from "react"
import H1 from "../../components/H1"
import * as styles from "./styles.module.css"

const Two = () => {
  return (
    <section className={styles.one}>
      <H1 text="Subscribe"></H1>

      <div className={styles.grid}>
        <div>
          <span>
            Subscribe today for access to our daily ETF Stock Report Service,
            available for individual investors and single advisors.
          </span>
        </div>
      </div>
    </section>
  )
}

export default Two
